import Vue from "vue";
import Vuex from "vuex";
// import mutations from './mutations'
// import actions from './actions'

import * as mutations from "../store/mutationTypes/types";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    activeServices: new Set(),
    basket: new Map(),
    currentPrice: 0,
  },
  getters: {
    currentPrice: (state) => {
      return state.currentPrice;
    },
    activeServices: (state) => {
      console.log(state.activeServices);
      return state.activeServices;
    },
  },
  mutations: {
    ADD_SERVICE(state, payload) {
      return state.activeServices.add(payload.service);
    },
    REMOVE_SERVICE(state, payload) {
      return state.activeServices.delete(payload.service);
    },
    SET_SERVICES(state, payload) {
      return (state.activeServices = payload);
    },
    MODIFY_AMOUNT(state, payload) {
      return (state.activeServices = payload);
    },
    INITIALIZE_BASKET(state, payload) {
      return (state.basket = payload);
    },
    MODIFY_BASKET(state, payload) {
      let updatedBasket = state.basket;
      updatedBasket.set(payload.key, payload.value);
      return (state.basket = updatedBasket);
    },
    MODIFY_PRICE(state, payload) {
      return (state.currentPrice = payload);
    },
  },
  actions: {
    addService(context, payload) {
      context.commit(mutations.ADD_SERVICE, payload);
    },
    removeService(context, payload) {
      context.commit(mutations.REMOVE_SERVICE, payload);
    },
    clearServices(context) {
      context.commit(mutations.SET_SERVICES, new Set());
    },
    modifyAmount(context, payload) {
      context.commit(mutations.MODIFY_AMOUNT, payload);
    },
    initializeBasket(context, payload) {
      let editedPayload = new Map();
      let form = JSON.parse(JSON.stringify(payload.form));
      form.categories.forEach((category) => {
        category.items.forEach((item) => {
          editedPayload.set(item.id, item);
        });
      });

      context.commit(mutations.INITIALIZE_BASKET, editedPayload);
    },
    modifyBasket(context, payload) {
      context.commit(mutations.MODIFY_BASKET, payload);

      //update total price
      let newPrice = 0;
      for (let value of this.state.basket.values()) {
        newPrice += value.price * value.amount;
      }
      context.commit(mutations.MODIFY_PRICE, newPrice);
    },
  },
});
